var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 756,
    height: 194,
    viewBox: "0 0 756 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.4 186.001V45.0006H354.2V65.4006H285V104.201H349.8V124.601H285V165.601H354.2V186.001H260.4Z",
    fill: "url(#paint0_linear_2209_591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.336 186.001V88.2006H401.736V105.401C406.536 93.8006 416.803 87.4006 432.536 86.2006L440.136 85.6006L441.736 106.801L427.336 108.201C410.936 109.801 402.736 118.201 402.736 133.401V186.001H377.336Z",
    fill: "url(#paint1_linear_2209_591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.657 186.001V88.2006H480.057V105.401C484.857 93.8006 495.123 87.4006 510.857 86.2006L518.457 85.6006L520.057 106.801L505.657 108.201C489.257 109.801 481.057 118.201 481.057 133.401V186.001H455.657Z",
    fill: "url(#paint2_linear_2209_591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.014 188.001C566.881 188.001 558.081 185.934 550.614 181.801C543.148 177.667 537.348 171.801 533.214 164.201C529.081 156.467 527.014 147.401 527.014 137.001C527.014 126.601 529.081 117.601 533.214 110.001C537.348 102.401 543.148 96.534 550.614 92.4006C558.081 88.2673 566.881 86.2006 577.014 86.2006C587.148 86.2006 595.948 88.2673 603.414 92.4006C610.881 96.534 616.681 102.401 620.814 110.001C624.948 117.601 627.014 126.601 627.014 137.001C627.014 147.401 624.948 156.467 620.814 164.201C616.681 171.801 610.881 177.667 603.414 181.801C595.948 185.934 587.148 188.001 577.014 188.001ZM577.014 169.001C584.481 169.001 590.481 166.334 595.014 161.001C599.548 155.534 601.814 147.534 601.814 137.001C601.814 126.334 599.548 118.401 595.014 113.201C590.481 107.867 584.481 105.201 577.014 105.201C569.548 105.201 563.548 107.867 559.014 113.201C554.481 118.401 552.214 126.334 552.214 137.001C552.214 147.534 554.481 155.534 559.014 161.001C563.548 166.334 569.548 169.001 577.014 169.001Z",
    fill: "url(#paint3_linear_2209_591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.649 186.001V88.2006H672.049V105.401C676.849 93.8006 687.115 87.4006 702.849 86.2006L710.449 85.6006L712.049 106.801L697.649 108.201C681.249 109.801 673.049 118.201 673.049 133.401V186.001H647.649Z",
    fill: "url(#paint4_linear_2209_591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.318 144.201L724.518 45.0006H755.318L747.518 144.201H732.318ZM725.918 186.001V158.201H753.918V186.001H725.918Z",
    fill: "url(#paint5_linear_2209_591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6603 120.587L83.4137 130.834L93.6603 141.081L83.4137 151.327L73.167 141.081L62.9203 151.327L52.6737 141.081L62.9203 130.834L52.6737 120.587L62.9203 110.341L73.167 120.587L83.4137 110.341L93.6603 120.587ZM151.08 110.341L140.834 120.587L130.587 110.341L120.34 120.587L130.587 130.834L120.34 141.081L130.587 151.327L140.834 141.081L151.08 151.327L161.327 141.081L151.08 130.834L161.327 120.587L151.08 110.341ZM213.334 126.001V155.001C213.334 160.317 208.984 164.667 203.667 164.667H194V174.334C194 185.064 185.397 193.667 174.667 193.667H39.3337C28.7003 193.667 20.0003 185.064 20.0003 174.334V164.667H10.3337C5.01699 164.667 0.666992 160.317 0.666992 155.001V126.001C0.666992 120.684 5.01699 116.334 10.3337 116.334H20.0003C20.0003 78.924 50.257 48.6673 87.667 48.6673H97.3336V36.3907C91.5336 33.104 87.667 26.8207 87.667 19.6673C87.667 9.03398 96.367 0.333984 107 0.333984C117.634 0.333984 126.334 9.03398 126.334 19.6673C126.334 26.8207 122.467 33.104 116.667 36.3907V48.6673H126.334C163.744 48.6673 194 78.924 194 116.334H203.667C208.984 116.334 213.334 120.684 213.334 126.001ZM194 135.667H174.667V116.334C174.667 89.654 153.014 68.0007 126.334 68.0007H87.667C60.987 68.0007 39.3337 89.654 39.3337 116.334V135.667H20.0003V145.334H39.3337V174.334H174.667V145.334H194V135.667Z",
    fill: "url(#paint6_linear_2209_591)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2209_591",
    x1: -28,
    y1: 28,
    x2: 808,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2209_591",
    x1: -28,
    y1: 28,
    x2: 808,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2209_591",
    x1: -28,
    y1: 28,
    x2: 808,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2209_591",
    x1: -28,
    y1: 28,
    x2: 808,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2209_591",
    x1: -28,
    y1: 28,
    x2: 808,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2209_591",
    x1: -28,
    y1: 28,
    x2: 808,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC016"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2209_591",
    x1: -28,
    y1: 28,
    x2: 808,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC016"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.71dfc1acd4b254dbd2716b203f8eafe3.svg";
export { ForwardRef as ReactComponent };